module.exports = __webpack_public_path__ + "static/media/ios-bookmark.c39612e8.svg";